import { useEffect } from 'react';
import { bootstrap, useStore } from './store.ts';
import { useT, useUiLocale } from './i18n.ts';
import { AcceptInvite, ConsentScreen, LoginScreen, ResetPassword } from './components/Auth.tsx';
import { Shell } from './components/Shell.tsx';
import { DiagPage } from './components/Diag.tsx';

export function App() {
  const phase = useStore((s) => s.phase);
  const t = useT();
  const uiLocale = useUiLocale();
  const path = location.pathname;
  const invite = path.match(/^\/invite\/([\w-]+)$/)?.[1];
  const reset = path.match(/^\/reset\/([\w-]+)$/)?.[1];
  const diag = path === '/diag';

  useEffect(() => {
    if (!invite && !reset && !diag) void bootstrap();
  }, [invite, reset, diag]);

  useEffect(() => {
    document.documentElement.lang = uiLocale === 'sv-SE' ? 'sv' : uiLocale === 'zh-Hans' ? 'zh-Hans' : 'en';
  }, [uiLocale]);

  if (diag) return <DiagPage />;
  if (invite) return <AcceptInvite token={invite} />;
  if (reset) return <ResetPassword token={reset} />;
  if (phase === 'loading') return <div className="splash" aria-busy="true">{t('connConnecting')}</div>;
  if (phase === 'anon') return <LoginScreen />;
  if (phase === 'consent') return <ConsentScreen />;
  return <Shell />;
}
